import "./i18n";

export { supportedLanguages } from "./resources";
export type { SupportedLanguages } from "./resources";
export { getInitialLang } from "./utils";
